import { ArrowLeft } from "@mui/icons-material";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";

export default function CurrentTimeIndicator({
    currentTime,
    scheduleStartTime,
    scheduleEndTime,
}) {
    const hideTime = useMediaQuery('(max-width:600px)');
    
    return (
        <Box
            id="CurrentTimeIndicatorBox"
            sx={{
                height: "100%",
                flex: "0 1 9em",
                position: "relative",
                minWidth: "5em",
            }}
        >
            <Stack
                id="CurrentTimeIndicator"
                direction="row"
                alignItems="center"
                sx={{
                    position: "absolute",
                    top: `${
                        ((currentTime - scheduleStartTime) / (scheduleEndTime - scheduleStartTime)) *
                        100
                    }%`,
                    transform: "translateY(-50%)",
                }}
            >
                <ArrowLeft />
                {(true || !hideTime) && <Typography>
                    {currentTime.toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                        timeZoneName: "short",
                    })}
                </Typography>}
            </Stack>
        </Box>
    );
}
